class KikReadMoreLess extends HTMLElement {
    constructor() {
        super();

        // Initialize the state and reference the content and button
        this.isExpanded = false;
        this.content = this.querySelector('.kik-readml-wrapper');
        this.toggleButton = this.querySelector('.kik-button'); // Selecting the button itself, not just the label

        // Parse the JSON configuration
        this.config = JSON.parse(this.querySelector('script[type="application/json"][data-readml]').textContent);
        if (!this.config || this.isEmptyObject(this.config)) return;

        this.readmoreText = this.config.readmore_text;
        this.readlessText = this.config.readless_text;

        // Media query breakpoints and heights
        this.heights = this.config.height;
        this.mediaQueries = this.config.media_queries;

        // Set initial target height
        this.targetHeight = this.numberOnly(this.getTargetHeight());
    }

    connectedCallback() {
        // Handle screen resize to adjust height
        window.addEventListener('resize', this.updateHeight.bind(this));

        // Set the initial height and content visibility
        this.updateHeight();

        // Re-check after fonts/images load since scrollHeight may change
        if (document.readyState !== 'complete') {
            window.addEventListener('load', () => this.updateHeight());
        }
        // Also re-check after a short delay for dynamically rendered content
        setTimeout(() => this.updateHeight(), 300);
        setTimeout(() => this.updateHeight(), 1000);

        // Add the click event listener to toggle the content
        this.toggleButton.addEventListener('click', this.toggleContent.bind(this));
        // this.toggleButton.addEventListener('mouseover', this.hoverOpen.bind(this));
    }

    getTargetHeight() {
        const mobileQuery = window.matchMedia(this.mediaQueries.mobile);
        const tabletQuery = window.matchMedia(this.mediaQueries.tablet);
        const desktopQuery = window.matchMedia(this.mediaQueries.desktop);

        if (desktopQuery.matches) {
            return this.heights.desktop;
        } else if (tabletQuery.matches) {
            return this.heights.tablet;
        } else if (mobileQuery.matches) {
            return this.heights.mobile;
        }
    }

    updateHeight() {
        // Update the target height based on current screen size
        this.targetHeight = this.numberOnly(this.getTargetHeight());

        // Check if content needs to be expanded or hidden based on height
        if ((this.content.scrollHeight) <= this.targetHeight || this.targetHeight <= 0) {
            // Content fits within target height, no toggle needed
            this.toggleButton.classList.add('hidden'); // Hide the button if not needed
            this.content.style.maxHeight = 'none'; // Allow full content display
        } else {
            // Content exceeds target height, show the button
            this.toggleButton.classList.remove('hidden'); // Show the button if needed
            if (!this.isExpanded) {
                this.content.style.maxHeight = `${this.targetHeight}px`; // Apply the restricted height
                this.content.style.overflow = 'hidden';
            }
        }
    }

    numberOnly(value) {
        let cleanedValue = value.replace(/[^\d.,]/g, '');
        cleanedValue = cleanedValue.replace(/,/g, '');
        let validNumber = parseFloat(cleanedValue);
        return isNaN(validNumber) ? null : validNumber;
    }

    isEmptyObject(obj) {
        return Object.keys(obj).length === 0;
    }

    toggleContent(event) {
        // Prevent the default button action (like submitting a form)
        event.preventDefault();

        this.isExpanded = !this.isExpanded;

        // Toggle expanded class and button text
        if (this.isExpanded) {
            this.content.style.maxHeight = 'none';
            this.content.style.paddingBottom = '30px';
            this.toggleButton.querySelector('.kik-button__label').textContent = `${this.readlessText}`;
            this.toggleButton.querySelector('.kik-button__label').classList.add('kik-button__label--expanded');
        } else {
            this.content.style.maxHeight = `${this.targetHeight}px`;
            this.toggleButton.querySelector('.kik-button__label').classList.remove('kik-button__label--expanded');
            this.toggleButton.querySelector('.kik-button__label').textContent = `${this.readmoreText}`;

            setTimeout(() => {
                this.content.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
            }, 50);
        }
    }

    hoverOpen(event) {
        event.preventDefault();
        this.isExpanded = !this.isExpanded;

        // Toggle expanded class and button text
        if (!this.isExpanded) {
            this.content.style.maxHeight = 'none';
            this.content.style.paddingBottom = '30px';
            this.toggleButton.querySelector('.kik-button__label').textContent = `${this.readlessText}`;
            this.toggleButton.querySelector('.kik-button__label').classList.add('kik-button__label--expanded');
        }
    }

    disconnectedCallback() {
        this.toggleButton.removeEventListener('click', this.toggleContent);
        window.removeEventListener('resize', this.updateHeight);
    }
}

// Define the custom element
customElements.define('kik-readml', KikReadMoreLess);